<template lang="pug">
.notification-setting-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="dark-boder-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // ヘッダー：家族メッセージ
    template(#head(message)="data")
      .d-flex.flex-column.justify-content-center
        .head-name 家族からの連絡／返信
        .input
          b-form-checkbox(v-model="_showText" :value="true" :unchecked-value="false" style="font-weight: normal;") メールに連絡内容を表示する
    // ヘッダー：施設関係者メッセージ
    template(#head(otherUserMessage)="data")
      .d-flex.flex-column.justify-content-center
        .head-name 施設関係者からの連絡／返信
        .input
          b-form-checkbox(v-model="_showText" :value="true" :unchecked-value="false" style="font-weight: normal;") メールに連絡内容を表示する
    // ヘッダー：他事業所連携メッセージ
    template(#head(otherOfficeMessage)="data")
      .d-flex.flex-column.justify-content-center
        .head-name 他事業所からのメッセージ
        .input
          b-form-checkbox(v-model="_showText" :value="true" :unchecked-value="false" style="font-weight: normal;") メールに連絡内容を表示する

    // セル：家族
    template(#cell(family)="row")
      template(v-if="row.item.groupId != 0")
        .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.family")
          b-form-input.mail-address.mr-1(
            v-model="row.item.family[index]" :name="row.item.groupId + '-family-' + index"
            size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
            v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
          b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.family, index)")
            .trash-icon
        .add-mailaddress-btn.mb-2
          b-button(@click="onAddMailAddressInputButton(row.item.family)") 通知先メールアドレス追加
        .error-messages-contents(v-for="(item, index) in row.item.family")
          .error-messages(v-for="error in errors.collect(row.item.groupId + '-family-' + index)")
            .error-message {{ error }}
    // セル：家族メッセージ
    template(#cell(message)="row")
      .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.message")
        b-form-input.mail-address.mr-1(
          v-model="row.item.message[index]" :name="row.item.groupId + '-message-' + index"
          size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
          v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
        b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.message, index)")
          .trash-icon
      .add-mailaddress-btn.mb-2
        b-button(@click="onAddMailAddressInputButton(row.item.message)") 通知先メールアドレス追加
      .error-messages-contents(v-for="(item, index) in row.item.message")
        .error-messages(v-for="error in errors.collect(row.item.groupId + '-message-' + index)")
          .error-message {{ error }}
    // セル：面会予約
    template(#cell(reservation)="row")
      template(v-if="row.item.groupId != 0")
        .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.reservation")
          b-form-input.mail-address.mr-1(
            v-model="row.item.reservation[index]" :name="row.item.groupId + '-reservation-' + index"
            size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
            v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
          b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.reservation, index)")
            .trash-icon
        .add-mailaddress-btn.mb-2
          b-button(@click="onAddMailAddressInputButton(row.item.reservation)") 通知先メールアドレス追加
        .error-messages-contents(v-for="(item, index) in row.item.reservation")
          .error-messages(v-for="error in errors.collect(row.item.groupId + '-reservation-' + index)")
            .error-message {{ error }}
    // セル：外出外泊届け
    template(#cell(outing)="row")
      template(v-if="row.item.groupId != 0")
        .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.outing")
          b-form-input.mail-address.mr-1(
            v-model="row.item.outing[index]" :name="row.item.groupId + '-outing-' + index"
            size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
            v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
          b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.outing, index)")
            .trash-icon
        .add-mailaddress-btn.mb-2
          b-button(@click="onAddMailAddressInputButton(row.item.outing)") 通知先メールアドレス追加
        .error-messages-contents(v-for="(item, index) in row.item.outing")
          .error-messages(v-for="error in errors.collect(row.item.groupId + '-outing-' + index)")
            .error-message {{ error }}
    // セル：イベント
    template(#cell(event)="row")
      template(v-if="row.item.groupId != 0")
        .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.event")
          b-form-input.mail-address.mr-1(
            v-model="row.item.event[index]" :name="row.item.groupId + '-event-' + index"
            size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
            v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
          b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.event, index)")
            .trash-icon
        .add-mailaddress-btn.mb-2
          b-button(@click="onAddMailAddressInputButton(row.item.event)") 通知先メールアドレス追加
        .error-messages-contents(v-for="(item, index) in row.item.event")
          .error-messages(v-for="error in errors.collect(row.item.groupId + '-event-' + index)")
            .error-message {{ error }}
    // セル：写真印刷依頼
    template(#cell(picture)="row")
      template(v-if="row.item.groupId != 0")
        .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.picture")
          b-form-input.mail-address.mr-1(
            v-model="row.item.picture[index]" :name="row.item.groupId + '-picture-' + index"
            size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
            v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
          b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.picture, index)")
            .trash-icon
        .add-mailaddress-btn.mb-2
          b-button(@click="onAddMailAddressInputButton(row.item.picture)") 通知先メールアドレス追加
        .error-messages-contents(v-for="(item, index) in row.item.picture")
          .error-messages(v-for="error in errors.collect(row.item.groupId + '-picture-' + index)")
            .error-message {{ error }}

    // セル：施設関係者
    template(#cell(otherUser)="row")
      template(v-if="row.item.groupId != 0")
        .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.otherUser")
          b-form-input.mail-address.mr-1(
            v-model="row.item.otherUser[index]" :name="row.item.groupId + '-other-user-' + index"
            size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
            v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
          b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.otherUser, index)")
            .trash-icon
        .add-mailaddress-btn.mb-2
          b-button(@click="onAddMailAddressInputButton(row.item.otherUser)") 通知先メールアドレス追加
        .error-messages-contents(v-for="(item, index) in row.item.otherUser")
          .error-messages(v-for="error in errors.collect(row.item.groupId + '-other-user-' + index)")
            .error-message {{ error }}
    // セル：施設関係者メッセージ
    template(#cell(otherUserMessage)="row")
      .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.otherUserMessage")
        b-form-input.mail-address.mr-1(
          v-model="row.item.otherUserMessage[index]" :name="row.item.groupId + '-other-user-message-' + index"
          size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
          v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
        b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.otherUserMessage, index)")
          .trash-icon
      .add-mailaddress-btn.mb-2
        b-button(@click="onAddMailAddressInputButton(row.item.otherUserMessage)") 通知先メールアドレス追加
      .error-messages-contents(v-for="(item, index) in row.item.otherUserMessage")
        .error-messages(v-for="error in errors.collect(row.item.groupId + '-other-user-message-' + index)")
          .error-message {{ error }}

    // セル：トピック送信・返信
    template(#cell(otherOfficeMessage)="row")
      .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.otherOfficeMessage")
        b-form-input.mail-address.mr-1(
          v-model="row.item.otherOfficeMessage[index]" :name="row.item.groupId + '-other-office-message-' + index"
          size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
          v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
        b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.otherOfficeMessage, index)")
          .trash-icon
      .add-mailaddress-btn.mb-2
        b-button(@click="onAddMailAddressInputButton(row.item.otherOfficeMessage)") 通知先メールアドレス追加
      .error-messages-contents(v-for="(item, index) in row.item.otherOfficeMessage")
        .error-messages(v-for="error in errors.collect(row.item.groupId + '-other-office-message-' + index)")
          .error-message {{ error }}
    // セル：オンライン会議
    template(#cell(otherOfficeOnlineMeeting)="row")
      .mail-address-input.mb-2.d-flex.flex-row.align-items-center(v-for="(item, index) in row.item.otherOfficeOnlineMeeting")
        b-form-input.mail-address.mr-1(
          v-model="row.item.otherOfficeOnlineMeeting[index]" :name="row.item.groupId + '-other-office-online-meeting-' + index"
          size="sm" type="email" placeholder="通知先メールアドレス" maxlength="100"
          v-validate="{ email: true, max: 100 }" :data-vv-as="(index + 1) + '目の宛先メールアドレス'")
        b-button.mail-address-delete-btn(@click="onDeleteMailAddressInputButton(row.item.otherOfficeOnlineMeeting, index)")
          .trash-icon
      .add-mailaddress-btn.mb-2
        b-button(@click="onAddMailAddressInputButton(row.item.otherOfficeOnlineMeeting)") 通知先メールアドレス追加
      .error-messages-contents(v-for="(item, index) in row.item.otherOfficeOnlineMeeting")
        .error-messages(v-for="error in errors.collect(row.item.groupId + '-other-office-online-meeting-' + index)")
          .error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 通知設定テーブルコンポーネント
 */
@Component({})
export default class NotificationSettingTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<NotificationSettingTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<NotificationSettingTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** メッセージで本文を表示するか */
  @Prop({ required: true })
  showText!: boolean;

  get _value(): Array<NotificationSettingTableItem> {
    return this.value;
  }

  get _showText(): boolean {
    return this.showText;
  }

  set _showText(newValue: boolean) {
    this.$emit("update:showText", newValue);
    return;
  }

  /**
   * ### 追加ボタン押下イベント
   */
  public onAddMailAddressInputButton(target: Array<string>): void {
    target.push("");
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   *
   * - 削除対象の配列長が1超であれば要素を削除する
   * - それ以外の場合は対象の要素の中身をリセットする
   */
  public onDeleteMailAddressInputButton(target: Array<string>, index: number): void {
    if (1 < target.length) {
      target.splice(index, 1);
    } else {
      target.splice(index, 1);
      target.push("");
    }
    return;
  }
}

/** テーブルの列名の情報 */
export interface NotificationSettingTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface NotificationSettingTableItem {
  /** 利用者グループID or 施設関係者グループID */
  groupId: number;
  /** 利用者グループID or 施設関係者グループID */
  groupName: string;

  // 家族ユーザー
  /** イベント */
  event: Array<string>;
  /** 家族 */
  family: Array<string>;
  /** 家族メッセージ */
  message: Array<string>;
  /** 写真印刷依頼 */
  picture: Array<string>;
  /** 面会予約 */
  reservation: Array<string>;
  /** 外出外泊届け */
  outing: Array<string>;

  // 施設関係者グループ
  /** 施設関係者 */
  otherUser: Array<string>;
  /** 施設関係者メッセージ */
  otherUserMessage: Array<string>;

  // 他事業所連携
  /** トピック送信・返信 */
  otherOfficeMessage: Array<string>;
  /** オンライン会議 */
  otherOfficeOnlineMeeting: Array<string>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.notification-setting-table-component {
  .error-messages-contents {
    .error-message {
      font-size: 14px !important;
    }
  }
  .mail-address-input {
    .mail-address {
      min-width: 300px;
    }
  }
  .mail-address-input,
  .add-mailaddress-btn {
    .btn {
      font-size: 14px !important;
      height: 30px !important;
      padding: 4px 8px !important;
    }
    .mail-address-delete-btn {
      padding: 2px 5px !important;
      .trash-icon {
        @include svg-icon("../../../assets/trash.svg", $font-base-color, 20px, 20px);
      }
    }
  }
  .add-mailaddress-btn {
    text-align: right;
  }
}
</style>
